// eslint-disable-next-line no-underscore-dangle
export default window.__CONFIG__;
